var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M26.0571 3.2H5.9428A2.743 2.743 0 0 0 3.2 5.9428v20.1143A2.743 2.743 0 0 0 5.943 28.8h7.8428v-8.7035h-3.6V16h3.6v-3.1223c0-3.5515 2.1143-5.5132 5.3525-5.5132 1.5509 0 3.1726.2766 3.1726.2766v3.4857H20.524c-1.7606 0-2.3098 1.0926-2.3098 2.2132V16h3.9303l-.6285 4.0965h-3.3018V28.8h7.8429A2.743 2.743 0 0 0 28.8 26.0571V5.9428A2.743 2.743 0 0 0 26.0571 3.2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook-footer.4b3308f29c58a902066168f8cc7bf375.svg";